import {IVideoSlidesRuleConfig} from "../../../configurations/config-data-sections/arenas.configuration";
import {GameInfo} from "../../../games/game-info";
import {ISlideRenderer} from "../../video-slides.service.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {ISlideRuleModel} from "./slide-rule-model.interface";

export abstract class SlideRuleBaseModel implements ISlideRuleModel {
    constructor(private readonly ruleConfig: IVideoSlidesRuleConfig,
                private readonly games: GameInfo[],
                protected readonly services: IServiceFactoryExtended) {
    }

    protected abstract createVideoSlideRenderer(gameInfo: GameInfo): ISlideRenderer;

    private _currentIndex = 0;

    appendToChunk(currentChunkContent: ISlideRenderer[]): ISlideRenderer[] {

        const slice = this.games.slice(this._currentIndex, this._currentIndex + this.ruleConfig.slidesChunkSize)
                                               .map(gameInfo => this.createVideoSlideRenderer(gameInfo))

        this._currentIndex += this.ruleConfig.slidesChunkSize;

        return [
            ...currentChunkContent,
            ...slice
        ];
    }

}